import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <div id="footer">

      <div className="footer-top">
        <div className="container">
          <div className="row">

            <div className="col-lg-3 col-md-6 footer-info">
              <h3>{t("footer.about.title")}</h3>
              <p>
                {t("footer.about.description")}
              </p>
              <div className="social-links mt-3">
                <a href="https://www.facebook.com/Kasab-Kablo-115338877004429" className="facebook"><i className="bx bxl-facebook"></i></a>
                <a href="https://www.instagram.com/kasabkablo99/" className="instagram"><i className="bx bxl-instagram"></i></a>
                <a href="https://tr.linkedin.com/company/kasab-kablo-elektri%CC%87k-san-ve-ti%CC%87c-ltd-%C5%9Fti%CC%87" className="linkedin"><i className="bx bxl-linkedin"></i></a>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 footer-links">
              <h4>{t("footer.links")}</h4>
              <ul>
                <li><i className="bx bx-chevron-right"></i> <Link to="/">{t("links.Home")}</Link></li>
                <li><i className="bx bx-chevron-right"></i> <Link to="/about">{t("links.AboutUs")}</Link></li>
                <li><i className="bx bx-chevron-right"></i> <Link to="/images">{t("links.Images")}</Link></li>
                <li><i className="bx bx-chevron-right"></i> <Link to="/products">{t("links.Products")}</Link></li>
                <li><i className="bx bx-chevron-right"></i> <Link to="/certificates">{t("links.Certificates")}</Link></li>
                <li><i className="bx bx-chevron-right"></i> <Link to="/contact">{t("links.Contact")}</Link></li>
                <li><i className="bx bx-chevron-right"></i> <Link to="/catalog">{t("links.eCatalog")}</Link></li>
              </ul>
            </div>

            <div className="col-lg-3 col-md-6 footer-links">
              <h4>{t("products.title")}</h4>
              <ul>
                <li><i className="bx bx-chevron-right"></i> <Link to="/products">{t("products.1")}</Link></li>
                <li><i className="bx bx-chevron-right"></i> <Link to="/products">{t("products.2")}</Link></li>
                <li><i className="bx bx-chevron-right"></i> <Link to="/products">{t("products.3")}</Link></li>
                <li><i className="bx bx-chevron-right"></i> <Link to="/products">{t("products.4")}</Link></li>
                <li><i className="bx bx-chevron-right"></i> <Link to="/products">{t("products.5")}</Link></li>
                <li><i className="bx bx-chevron-right"></i> <Link to="/products">{t("products.6")}</Link></li>
              </ul>
            </div>

            <div className="col-lg-3 col-md-6 footer-contact">
              <h4>{t("footer.contactUs.title")}</h4>
              <p>
                {t("footer.contactUs.address1")}<br />
                {t("footer.contactUs.address2")}<br /><br />
                <strong>{t("footer.contactUs.phone")}: </strong> <a href="tel:+902127710994">+90 212 771 09 94</a><br />
                <strong>Fax: </strong> +90 212 771 09 95<br />
                <strong>{t("footer.contactUs.mobile")}: </strong> <a href="tel:+905312881322">+90 531 288 13 22</a><br />
                <strong>Whatsapp: </strong> <a href="https://wa.me/905312881322">+90 531 288 13 22</a><br />
                <strong>Mail: </strong> <a href="mailto:sales@kasabkablo.com">sales@kasabkablo.com</a><br />
              </p>
            </div>

          </div>
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#fff" }}>
        <img style={{ maxWidth: "90%", maxHeight: "50px" }} src="/assets/img/kalite-belgeleri.png" alt="" />
      </div>
    </div >
  );
}
export default Footer;
